// Espelho de OCORRENCIA_TIPOS do backend (classificação é decidida no servidor)
export const OCORRENCIA_TIPOS_GESTAO = [
  ["cliente_ausente", "Cliente ausente", "logistica"],
  ["endereco_nao_encontrado", "Endereço não encontrado", "logistica"],
  ["produto_nao_entregue", "Produto não entregue", "geral"],
  ["aguardar_ordem_montagem", "Aguardar ordem de montagem", "geral"],
  ["menor_de_idade", "Menor de 18 anos na residência", "geral"],
  ["ambiente_inseguro", "Ambiente inseguro para o trabalho", "geral"],
  ["assistencia_tecnica", "Produto com assistência técnica", "produto"],
  ["nao_deu_montagem", "Produto não deu montagem", "produto"],
  ["peca_faltante", "Peça faltante", "produto"],
  ["peca_errada", "Peça errada / incompatível", "produto"],
  ["peca_avariada", "Peça avariada", "produto"],
  ["ferragem_incorreta", "Ferragem incorreta / insuficiente", "produto"],
  ["dano_execucao", "Dano durante a execução", "geral"],
  ["exige_ancoragem", "Produto exige ancoragem / fixação especial", "geral"],
  ["fora_do_escopo", "Serviço fora do escopo da OS", "geral"],
  ["outro", "Outro", "geral"],
];
